import store from "../../index";
import * as actionTypes from "./actionTypes";

export const success = (message) => {
  store.dispatch({ type: actionTypes.SUCCESS, message });
};
export const error = (message) => {
  store.dispatch({ type: actionTypes.ERROR, message });
};
export const warning = (message) => {
  store.dispatch({ type: actionTypes.WARNING, message });
};
export const info = (message) => {
  store?.dispatch({ type: actionTypes.INFO, message });
};
export const clearSnackbar = () => {
  store.dispatch({ type: actionTypes.SNACKBAR_CLEAR });
};
